<div class="content-layout section-spacing" [style.--accent]="accentColor">
  <!-- TOC SIDEBAR -->
  <aside class="toc" [class.is-sticky]="isTocSticky">
    <div class="toc-title">On this page</div>
    <ul class="toc-list">
      @for (item of config.tocItems; track item.id) {
        <li>
          <a
            [href]="'#' + item.id"
            [class.active]="activeSection === item.id"
            (click)="scrollTo(item.id, $event)"
          >
            {{ item.label }}
          </a>
        </li>
      }
    </ul>
  </aside>

  <!-- MAIN CONTENT -->
  <div class="main-content">
    <!-- MOBILE TOC -->
    <nav class="toc-mobile">
      <div class="toc-mobile-title">Table of Contents</div>
      <ul class="toc-mobile-list">
        @for (item of config.tocItems; track item.id) {
          <li>
            <a
              [href]="'#' + item.id"
              [class.active]="activeSection === item.id"
              (click)="scrollTo(item.id, $event)"
            >
              {{ item.label }}
            </a>
          </li>
        }
      </ul>
    </nav>

    <!-- SECTION 1: DEFINITION -->
    <section class="content-section" [id]="config.definition.id">
      <div class="section-eyebrow">{{ config.definition.eyebrow }}</div>
      <h2 class="section-title">{{ config.definition.title }}</h2>
      <div class="definition-box">
        <p [innerHTML]="safe(config.definition.definitionHtml)"></p>
        <cite>{{ config.definition.definitionCite }}</cite>
      </div>
      @for (para of config.definition.bodyHtml; track $index) {
        <p class="section-body" [innerHTML]="safe(para)"></p>
      }
    </section>

    <!-- SECTION 2: PROCESSES (optional) -->
    @if (config.processes; as processes) {
      <section class="content-section" [id]="processes.id">
        <div class="section-eyebrow">{{ processes.eyebrow }}</div>
        <h2 class="section-title">{{ processes.title }}</h2>
        <p class="section-body">{{ processes.intro }}</p>
        <div class="process-grid">
          @for (card of processes.items; track card.title) {
            <div class="process-card">
              @if (card.icon) {
                <div class="process-icon">
                  <img [src]="card.icon" [alt]="card.title" width="40" height="40" />
                </div>
              }
              <h4>{{ card.title }}</h4>
              <p>{{ card.description }}</p>
            </div>
          }
        </div>
      </section>
    }

    <!-- SECTION 3: COMPARE -->
    <section class="content-section" [id]="config.compare.id">
      <div class="section-eyebrow">{{ config.compare.eyebrow }}</div>
      <h2 class="section-title">{{ config.compare.title }}</h2>
      @if (config.compare.intro) {
        <p class="section-body">{{ config.compare.intro }}</p>
      }
      <div class="table-wrapper">
        <table class="compare-table">
          <thead>
            <tr>
              <th>{{ config.compare.headers?.[0] ?? 'Term' }}</th>
              <th>{{ config.compare.headers?.[1] ?? 'What it manages' }}</th>
              @if (compareHasFocus) {
                <th>{{ config.compare.headers?.[2] ?? 'Primary focus' }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of config.compare.rows; track $index) {
              <tr>
                <td>
                  @if (row.term) {
                    <span class="tag" [ngClass]="row.tagClass">{{ row.term }}</span>
                  }
                  @if (row.term && row.termFull) {
                    <br />
                  }
                  {{ row.termFull }}
                </td>
                <td>{{ row.manages }}</td>
                @if (compareHasFocus) {
                  <td>{{ row.focus }}</td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>

    <!-- SECTION 4: BENEFITS -->
    <section class="content-section" [id]="config.benefits.id">
      <div class="section-eyebrow">{{ config.benefits.eyebrow }}</div>
      <h2 class="section-title">{{ config.benefits.title }}</h2>
      <p class="section-body">{{ config.benefits.intro }}</p>
      <div class="benefits-list">
        @for (benefit of config.benefits.items; track benefit.num) {
          <div class="benefit-row">
            <div class="benefit-num">{{ benefit.num }}</div>
            <div class="benefit-text">
              <h4>{{ benefit.title }}</h4>
              <p>{{ benefit.description }}</p>
            </div>
            <div class="benefit-arrow">→</div>
          </div>
        }
      </div>
    </section>

    <!-- SECTION 5: FAQ -->
    <section class="content-section" [id]="config.faq.id">
      <div class="section-eyebrow">{{ config.faq.eyebrow }}</div>
      <h2 class="section-title">{{ config.faq.title }}</h2>
      <div class="faq-list">
        @for (faq of config.faq.items; track faq.question; let i = $index) {
          <div class="faq-item" [class.open]="faq.open">
            <button
              class="faq-q"
              [class.open]="faq.open"
              (click)="toggleFaq(i)"
              [attr.aria-expanded]="faq.open"
            >
              <span>{{ faq.question }}</span>
              <div class="faq-chevron" [class.rotated]="faq.open">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M2 4L6 8L10 4"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </button>
            <div class="faq-a" [class.visible]="faq.open">
              <div class="faq-a-inner">{{ faq.answer }}</div>
            </div>
          </div>
        }
      </div>
    </section>
  </div>
</div>
